export const ADD_LIST_AMENITY = 'ADD_LIST_AMENITY';
export const ADD_AMENITY = 'ADD_AMENITY';
export const UPDATE_AMENITY = 'UPDATE_AMENITY';
export const DELETE_AMENITY = 'DELETE_AMENITY';